import React from 'react'
import components from '../components'
import screens from '../screens'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'
const AuthLayout = () => {
  const role=localStorage.getItem('role')
  return (
<>


       <div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",height:'100vh'}}>
      
      <components.layoutsCommponents.Vertical/>
      <div style={{display:'flex',flexDirection:"column",width:"100%"}}>
      <components.layoutsCommponents.horizontal/>
      <div style={{height:"100vh",maxWidth:"80%",marginLeft:"20%", padding:"0 3rem"}}>

      {!role?<Outlet/>:<Navigate to="/admin-panel/Dashboard"/>}
      </div>
      
      </div>
      
    
      </div>
</>
  )
}

export default AuthLayout